import { Permission } from '../resources/models/permission.enum';
import { MenuItem } from '../models/menu-item';
import { environment } from '../../environments/environment';

export const SidebarMenu: MenuItem[] = [
  {
    text: 'MAIN NAVIGATION',
    heading: true,
    permissions: [
      Permission.VIEW_CUSTOMERS,
      Permission.VIEW_JOBS,
      Permission.VIEW_REPORTS,
      Permission.VIEW_SERVICES,
      Permission.VIEW_LOGGING,
      Permission.DEVELOPER,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'Clients',
    elink: `${environment.platformUiUrl}/#/app/customers`,
    icon: 'fas fa-sitemap',
    permissions: [
      Permission.VIEW_CUSTOMERS,
    ],
  },
  {
    text: 'Jobs',
    elink: `${environment.platformUiUrl}/#/app/jobs`,
    icon: 'fas fa-tasks',
    permissions: [
      Permission.VIEW_JOBS,
    ],
  },
  {
    text: 'Feeds Status',
    elink: `${environment.platformUiUrl}/#/app/customer_feeds`,
    icon: 'fas fa-file-alt',
    permissions: [
      Permission.VIEW_JOBS,
    ],
  },
  {
    text: 'Analytics',
    elink: `${environment.platformUiUrl}/#/app/analytics`,
    icon: 'fas fa-chart-pie',
    permissions: [
      Permission.VIEW_REPORTS,
    ],
  },
  {
    text: 'Services',
    elink: `${environment.platformUiUrl}/#/app/services`,
    icon: 'fas fa-cubes',
    permissions: [
      Permission.VIEW_SERVICES,
    ],
  },
  {
    text: 'Developer',
    elink: `${environment.platformUiUrl}/#/app/developer`,
    icon: 'fas fa-code',
    permissions: [
      Permission.DEVELOPER,
    ],
  },
  {
    text: 'STRATEGY WORKBENCH',
    heading: true,
    permissions: [
      Permission.VIEW_CUSTOMER_STRATEGY,
      Permission.APPROVE_CUSTOMER_STRATEGY,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'Global Taxonomy',
    elink: `${environment.platformUiUrl}/#/app/taxonomy_versions`,
    icon: 'fas fa-globe',
    permissions: [
      Permission.VIEW_CUSTOMER_STRATEGY,
      Permission.VIEW_GLOBAL_TAXONOMY,
    ],
    permissionMatch: 'all',
  },
  {
    text: 'Product Classification',
    elink: `${environment.platformUiUrl}/#/app/product_mapping`,
    icon: 'fas fa-map-signs',
    permissions: [
      Permission.VIEW_GLOBAL_CLASSIFICATION_RULES,
    ],
  },
  {
    text: 'Client Strategy',
    elink: `${environment.platformUiUrl}/#/app/strategy_versions`,
    icon: 'fas fa-map',
    permissions: [
      Permission.VIEW_CUSTOMER_STRATEGY,
      Permission.APPROVE_CUSTOMER_STRATEGY,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'Guidelines',
    elink: `${environment.platformUiUrl}/#/app/guidelines`,
    icon: 'fas fa-book',
    permissions: [
      Permission.VIEW_GUIDELINES,
      Permission.EDIT_GUIDELINES,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'CURATION WORKBENCH',
    heading: true,
    permissions: [
      Permission.VIEW_CURATION_JOBS,
      Permission.PERFORM_CURATION_TASKS,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'Attribution Rules',
    elink: `${environment.platformUiUrl}/#/app/curation_rules`,
    icon: 'fas fa-cogs',
    permissions: [
      Permission.MANAGE_CURATION_RULES,
    ],
  },
  {
    text: 'Machine Training',
    elink: `${environment.platformUiUrl}/#/app/machine_training`,
    icon: 'fas fa-train',
    permissions: [
      Permission.MANAGE_MACHINE_CURATION,
    ],
  },
  {
    text: 'Machine Curation',
    elink: `${environment.platformUiUrl}/#/app/machine_curation`,
    icon: 'fab fa-android',
    permissions: [
      Permission.MANAGE_MACHINE_CURATION,
    ],
  },
  {
    text: 'Curation Management',
    elink: `${environment.platformUiUrl}/#/app/client_curation_management`,
    icon: 'fas fa-list-alt',
    permissions: [
      Permission.MANAGE_CURATION_JOBS,
    ],
  },
  {
    text: 'Curation Performance',
    elink: `${environment.platformUiUrl}/#/app/curation_performance`,
    icon: 'fas fa-chart-area',
    permissions: [
      Permission.VIEW_CURATION_PERFORMANCE,
    ],
  },
  {
    text: 'Chat Management',
    elink: `${environment.platformUiUrl}/#/app/chat_management`,
    icon: 'fas fa-comments',
    permissions: [
      Permission.MANAGE_CURATION_JOBS,
    ],
  },
  {
    text: 'Curation Tasks',
    elink: `${environment.platformUiUrl}/#/app/curation_tasks`,
    icon: 'fas fa-tasks',
    permissions: [
      Permission.PERFORM_CURATION_TASKS,
    ],
  },
  {
    text: 'INSIGHTS',
    heading: true,
    permissions: [
      Permission.VIEW_INSIGHTS,
      Permission.VIEW_ATTRIBUTE_INTELLIGENCE,
      Permission.VIEW_USAGE_DASHBOARD,
    ],
    permissionMatch: 'any',
  },
  {
    text: 'Insights',
    elink: `${environment.platformUiUrl}/#/app/insights`,
    icon: 'fa fa-chart-line',
    permissions: [
      Permission.VIEW_INSIGHTS,
    ],
  },
  {
    text: 'Attribute Intelligence',
    elink: `${environment.platformUiUrl}/#/app/attribute-intelligence`,
    icon: 'fa fa-chart-bar',
    permissions: [
      Permission.VIEW_ATTRIBUTE_INTELLIGENCE,
    ],
  },
  {
    text: 'Usage Dashboard',
    elink: `${environment.platformUiUrl}/#/app/usage-dashboard`,
    icon: 'fas fa-tachometer-alt',
    permissions: [
      Permission.VIEW_USAGE_DASHBOARD,
    ],
  },
  {
    text: 'USER MANAGEMENT',
    heading: true,
    permissions: [
      Permission.MANAGE_USERS,
      Permission.MANAGE_ROLES,
    ],
  },
  {
    text: 'Users',
    elink: `${environment.platformUiUrl}/#/app/users`,
    icon: 'fas fa-users',
    permissions: [
      Permission.MANAGE_USERS,
    ],
  },
  {
    text: 'Roles',
    elink: `${environment.platformUiUrl}/#/app/roles`,
    icon: 'fas fa-rocket',
    permissions: [
      Permission.MANAGE_ROLES,
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/menu.ts